import { render, staticRenderFns } from "./CreditClassTeacherBulkSave.vue?vue&type=template&id=af647be8&"
import script from "./CreditClassTeacherBulkSave.vue?vue&type=script&lang=js&"
export * from "./CreditClassTeacherBulkSave.vue?vue&type=script&lang=js&"
import style0 from "./CreditClassTeacherBulkSave.vue?vue&type=style&index=0&id=af647be8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports